import * as React from 'react';

/*
 * SearchField — the universal search treatment (.ps-search in tokens.css):
 * magnifier, sunk fill, 10px radius, accent border on focus. Every search
 * bar in v2 renders through this.
 */

interface SearchFieldProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    className?: string;
    autoFocus?: boolean;
}

export default function SearchField({
    value,
    onChange,
    placeholder,
    className,
    autoFocus,
}: SearchFieldProps) {
    return (
        <div className={'ps-search ' + (className ?? '')}>
            <svg
                width="15"
                height="15"
                viewBox="0 0 16 16"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                aria-hidden
            >
                <circle cx="7" cy="7" r="4.5" />
                <path d="m13.5 13.5-3-3" />
            </svg>
            <input
                autoFocus={autoFocus}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
            />
        </div>
    );
}
